import React, { ReactElement, ReactSVGElement, useEffect, useRef, useState } from 'react';
import { 
	BgColorCell, 
	Cell, 
	CellHeaderComponents, 
	ContainerGrafic, 
	ContainerHandImages, 
	ContainerHeader, 
	ContainerHeaderComponents, 
	ContainerIcon, 
	ContainerInfoImage, 
	ContainerLegend, 
	ContainerReference, 
	ContainerReport, 
	ContainerReportinfo, 
	ContainerReportOptions, 
	ContainerSection, 
	ContainerTable, 
	ContainerTextUpdateResult, 
	ContentLegend, 
	ContentOptionLegend, 
	ContentTable, 
	ContentUserInfo, 
	HandContainer, 
	HeaderInfo, 
	OptionL, 
	Press, 
	ReportOptions, 
	RowTable, 
	Square, 
	TextCellAssimetryEvolution, 
	TextLegend 
} from './styles';

import { TextsProps } from '../../../database/txt.interface';
import { useDispatch, useSelector } from 'react-redux';
import { PacientesProps } from '../../../interfaces/pacientes.interface';
import { Colors } from '../../../styles/colors';
import Texts from '../../../components/Texts/Text';

import * as V from "victory";

import {ReactComponent as Hand} from '../../../assets/kinologyIcons/svg/front_hand.svg';
import {ReactComponent as EvolAssi} from '../../../assets/kinologyIcons/svg/EvolAss.svg';

import {ReactComponent as HandLeftRed} from '../../../assets/kinologyIcons/palmarGrip/svg/HandlLeftRed.svg';
import {ReactComponent as HandLeftYellow} from '../../../assets/kinologyIcons/palmarGrip/svg/HandLeftYellow.svg';
import {ReactComponent as HandLeftGreen} from '../../../assets/kinologyIcons/palmarGrip/svg/HandleftGreen.svg';
import {ReactComponent as HandLeftNeutral} from '../../../assets/kinologyIcons/palmarGrip/svg/HandLeftNeutral.svg';
import {ReactComponent as HandLeftEmpty} from '../../../assets/kinologyIcons/palmarGrip/svg/HandLeftEmptyValue.svg';

import {ReactComponent as HandRightNeutral} from '../../../assets/kinologyIcons/palmarGrip/svg/HandRightNeutral.svg';
import {ReactComponent as HandRightGreen} from '../../../assets/kinologyIcons/palmarGrip/svg/HandRightGreen.svg';
import {ReactComponent as HandRightYellow} from '../../../assets/kinologyIcons/palmarGrip/svg/HandRightYellow.svg';
import {ReactComponent as HandRightRed} from '../../../assets/kinologyIcons/palmarGrip/svg/HandRightRed.svg';
import {ReactComponent as HandRightEmpty} from '../../../assets/kinologyIcons/palmarGrip/svg/HandRightEmptyValue.svg';

import {ReactComponent as Refresh} from '../../../assets/kinologyIcons/svg/refresh.svg';
import {ReactComponent as JoiaPositivo} from '../../../assets/kinologyIcons/svg/JoiaPositivo.svg';
import {ReactComponent as JoiaNegative} from '../../../assets/kinologyIcons/svg/JoiaNegative.svg';
import {ReactComponent as Warning} from '../../../assets/kinologyIcons/svg/WaringRedRound.svg';
import {ReactComponent as AgeGroup65} from '../../../assets/kinologyIcons/svg/AgeGroupe65.svg';
import {ReactComponent as Arrow} from '../../../assets/kinologyIcons/svg/arrow_drop.svg';
import {ReactComponent as CheckRound} from '../../../assets/kinologyIcons/svg/checkRound.svg';
import ReturnIcon from "../../../assets/icons/back_page.svg";
import Perfil from "../../../assets/icons/perfil.svg";
import PdfIcon from "../../../assets/kinologyIcons/svg/pdf.svg";

import { ContainerDash, Icon, ProfilePicture, Return } from '../../../styles/global';
import { P3Desk, S1Desk } from '../../../styles/styles_text';
import { DashBoardActions } from '../../../store/ducks/dashboard';
import { TitleButtonFormSubmiteProps } from '../../../components/Texts/Text/Models';
import moment from 'moment';
import { FieldError } from 'react-hook-form';
import { TypesCores, TypesLanguage } from '../../../utils/types';

enum CurrentOptionSelected {
	PRENSAO_PALMAR = 'PRENSAO_PALMAR',
	EVOLUCAO_ASSIMETRIA = 'EVOLUCAO_ASSIMETRIA',
};
interface ImagesProps {
	icon:ReactElement,
	side: string,
	dominantSide: boolean,
	align: string,
};
interface Execucoes {
  [lado: string]: any[]; 
};
interface IndicativoSaude {
  lado: string;
  forca: number;
  resultado: string;
	parametros_fraca:string,
	parametros_intermediaria: string,
	parametros_normal: string,

};
interface assimetriaProps {
	ID_EXERCICIO: string,
	MUSCULO: string,
	LABEL_EXERCICIO: number,
	EXERCICIO_TITULO_PT: string,
	EXERCICIO_TITULO_EN: string,
	EXERCICIO_TITULO_ES: string,
	EXECUCOES: Array<{
		DATA: string,
		MAXEXEC_D:number, 
		MAXEXEC_E:number, 
		ASSIMETRIA_VALOR: string,
		LEGENDA_ASSIMETRIA: 'NEGATIVO'|'INTERMEDIARIO'|'POSITIVO'|'NEUTRO',
		indicativo:  IndicativoSaude
	}>
};
interface PreensaoPalmar {
	preensao_palmar:{
		assimetrias: assimetriaProps; 
		referencia_dominante: number;
		referencia_nao_dominante: number;
		lado_dominante: string;
		lado_nao_dominante: string;
		execucoes: Execucoes;
		indicativo_saude: IndicativoSaude;
	},
};
type keyComponents = {
	[key:string]: ReactElement
};
type typeColors = {
	[key:string]:string
};

const ReportPalmar:React.FC = ()=> {

	const dispatch = useDispatch();
	
	const current_language: TextsProps = useSelector(	(state: any) => state.configs.current_language);
	const dataReport: any = useSelector((state:any)=> state.dashboard.palmar_gripe_data);
	const language = useSelector((state: any) => state.configs.language);
	const patient: PacientesProps = useSelector(	(state: any) => state.app.is_open_paciente);
	const [currentOption, setCurrentoption] = useState(CurrentOptionSelected.PRENSAO_PALMAR);
	const [legend, setLegend] = useState(false);
	const [currentData, SetCurrentData] = useState<any>([]);

	const reportOptions = [
		{
			icon:<Hand color={Colors?.secondary_green_k_main}/>,
			title: current_language?.prensao_palmar_title,
			label: CurrentOptionSelected.PRENSAO_PALMAR
		},
		{
			icon:<EvolAssi />,
			title: current_language?.evolucao_assimetria_title,
			label: CurrentOptionSelected.EVOLUCAO_ASSIMETRIA
		},
	];

	useEffect(()=>{
 		const array_history: any = [];

		dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.forEach((e: { DATA: moment.MomentInput; MAXEXEC_D: number; LEGENDA_ASSIMETRIA: any; MAXEXEC_E: number; })=>{
			const datD = {
				x: moment(e.DATA).format('DD/MM/YY'),
				y: e.MAXEXEC_D,
				position: 'D',
				color: e.LEGENDA_ASSIMETRIA,
				maior: e.MAXEXEC_E > e.MAXEXEC_D ? e.MAXEXEC_E : e.MAXEXEC_D,
				valor_e: e.MAXEXEC_E,
			};
			const datE = {
				x: moment(e.DATA).format('DD/MM/YY'),
				y: e.MAXEXEC_E,
				position: 'E',
				color: e.LEGENDA_ASSIMETRIA,
				maior: e.MAXEXEC_E > e.MAXEXEC_D ? e.MAXEXEC_E : e.MAXEXEC_D,
				valor_d: e.MAXEXEC_D,
			};
			array_history.push({
				name_exer: language == TypesLanguage.PT
				? dataReport?.preensao_palmar?.assimetrias?.EXERCICIO_TITULO_PT
				: language == TypesLanguage.EN
				? dataReport?.preensao_palmar?.assimetrias?.EXERCICIO_TITULO_EN
				: dataReport?.preensao_palmar?.assimetrias?.EXERCICIO_TITULO_ES,
				arr_d: [datD],
				arr_e: [datE],
			});
		})
		SetCurrentData([...array_history])
	},[dataReport]);

	const selectHandImage = (side: 'D'| 'E', level:'NEGATIVO'|'INTERMEDIARIO'|'POSITIVO'|'NEUTRO' )=> {

		const images = {
			'D':{
				'NEGATIVO':<HandRightRed/>,
				'INTERMEDIARIO':<HandRightYellow />,
				'POSITIVO': <HandRightGreen/>,
				'NEUTRO':<HandRightNeutral />,
				'EMPTY':<HandRightEmpty />
			},
			'E':{
				'NEGATIVO':<HandLeftRed/>,
				'INTERMEDIARIO':<HandLeftYellow />,
				'POSITIVO': <HandLeftGreen/>,
				'NEUTRO':<HandLeftNeutral />,
				'EMPTY':<HandLeftEmpty />
			}
		};
		return images[side][level]
	};

	const MaxExecRight = dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.MAXEXEC_D;
	const MaxExecLeft = dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.MAXEXEC_E;
	const CaptionAssimetry: 'NEGATIVO'|'INTERMEDIARIO'|'POSITIVO'|'NEUTRO'  = dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.LEGENDA_ASSIMETRIA;

	const HandImages:ImagesProps[] = [
		{
			icon: dataReport?.preensao_palmar?.assimetrias?.ID_EXERCICIO && dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.length != 0  
				? selectHandImage('D',	MaxExecRight >= MaxExecLeft ? 'NEUTRO' : CaptionAssimetry) 
				: <HandRightEmpty/>,
			side: 'D',
			dominantSide: dataReport?.preensao_palmar?.lado_dominante == 'D' ? true : false,
			align: 'flex-end',
		},
		{
			icon: dataReport?.preensao_palmar?.assimetrias?.ID_EXERCICIO && dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.length != 0 
				? selectHandImage('E', MaxExecLeft  >= MaxExecRight ? 'NEUTRO' : CaptionAssimetry)  
				: <HandLeftEmpty/>,
			side: 'E',
			dominantSide: dataReport?.preensao_palmar?.lado_dominante == 'E' ? true : false,
			align: 'flex-start',
		},
	];

	const HandleImages = (item: ImagesProps, index:number)=> {
		return (
			<HandContainer 
				key={index} 
				align={item.align}
			>
				<div style={{position: 'relative'}}>
					{item.icon}

				</div>
				<ContainerInfoImage
					top={50}
					visible
					left={item.side == 'E' ? 90 : 0}
					right={item.side == 'D' ? 90 : 0}
				>
					<Texts
						title={item.side}
						fontFamily='NotoSans-Regular'
						fontSize={1}
						marginLeft={5}
						textColor={'#8B8B8B'}
						fontWeight={ 600  }
						width={'60%'}
					/>
				</ContainerInfoImage>
				<ContainerInfoImage
					top={185}
					visible={item.dominantSide}
					borderBottom
					left={item.side == 'E' ? -75 : 0}
					right={item.side == 'D' ? -75 : 0}
				>
					<Texts
						title={'DOMINANTE'}
						fontFamily='NotoSans-Regular'
						fontSize={0.875}
						marginLeft={item.side == 'D' ? 25 : 0}
						marginRight={item.side == 'E' ? 20 : 0}
						textColor={'#8B8B8B'}
						textAlign={item.side == 'D' ? 'right' : 'left' }
					/>
				</ContainerInfoImage>
			</HandContainer>
		)
	};

	const UpdateResults = (align:'center'|'flex-start')=> {
		return (
				<ContainerTextUpdateResult 
					onClick={()=>dispatch(DashBoardActions.preensao_palmar_request(patient?.ID_USUARIO))}
					style={{
						alignSelf: align,
						justifyContent: align,
					}}
				>
					<Texts
						title={current_language?.atualizar_resultados}
						fontFamily='NotoSans-Regular'
						fontSize={0.875}
						textColor={Colors.neutral_grey_k_50}
						fontWeight={ 600 }
						marginRight={5}
						textDecoration='underline'
						cursor='pointer'
						textAlign='left'
					/>
						<Refresh color={Colors.neutral_grey_k_50}/>
				</ContainerTextUpdateResult>
		)
	};
	const AssimetryColors: typeColors = {
		'fraca': Colors.tertirary_red_1_dark+50,
		'intermediaria': Colors.tertiary_yellow_1_light+70,
		'normal': Colors.tertiary_green_1_light+60,
	};
	const AssimetryEvolutionColors: typeColors = {
		'NEGATIVO': Colors.tertirary_red_1_dark+50,
		'INTERMEDIARIO': Colors.tertiary_yellow_1_light+70,
		'POSITIVO': Colors.tertiary_green_1_light+60,
	};

	function changeOperators(valor:string) {
		if (typeof valor !== 'string') return valor;

		return valor
			.replace(/>=/g, '≧')
			.replace(/<=/g, '≦');
	};

	const HandlerWeakComponent = ()=> {

		const HeaderWeakComponent = [
			{	
				title: current_language?.prensao_fraca,
				reference: changeOperators(dataReport?.preensao_palmar?.indicativo_saude?.parametros_fraca),
				icon: <AgeGroup65 
								color={Colors.neutral_grey_k_70}
								style={{
									position: 'absolute',
									top:5,
									right:5
								}}
							/>,
				width: 50
			},
			{	
				title: current_language?.prensao_intermediaria,
				reference: changeOperators(dataReport?.preensao_palmar?.indicativo_saude?.parametros_intermediaria),
				icon:'',
				width: 30
			},
			{	
				title: current_language?.prensao_normal,
				reference: changeOperators(dataReport?.preensao_palmar?.indicativo_saude?.parametros_normal),
				icon:'',
				width: 20
			},
		];

		const dataRows = [
			{
				title: current_language?.risco_comprometimento_funcional,
				value: current_language?.impacto_capacidade_funcional,
			},
			{
				title: current_language?.risco_quedas,
				value: current_language?.aumento_risco_quedas,
			},
			{
				title: current_language?.aumento_risco_quedas,
				value: current_language?.potencial_risco_sarcopenia,
			},
		];

		return (
			<>
				<ContainerHeaderComponents>
					{
						HeaderWeakComponent.map((item, index)=>(
							<CellHeaderComponents
								key={index}
								width={item.width}
								borderLeftWidth={index == 0 ? 1 : 0}
								borderRightWidth={index == 0 ? 1 : 0}
								borderTopWidth={index == 0 ? 1 : 0}
								borderBottomWidth={index !== 0 ? 1 : 0}
								borderColor={Colors.tertirary_red_2_dark}
								borderTopRightRadius={index == 0 ? 10 : 0}
								bgColor={index == 0 ? Colors.tertirary_red_2_dark+33 : Colors.white}
							>
								<Texts
									title={item.title}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									textColor={index == 0 ? Colors.neutral_grey_k_70 : Colors.neutral_grey_k_30}
									fontWeight={index == 0 ? 600 : 400}
									textAlign={'left'}
								/>
								{item.icon}
								<Texts
									title={item.reference}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									textColor={index == 0 ? Colors.neutral_grey_k_70 : Colors.neutral_grey_k_30}
									marginTop={4}
									textAlign={'left'}
								/>
							</CellHeaderComponents>
						))
					}
					
				
				</ContainerHeaderComponents>
				<RowTable
					bgColor={Colors.tertirary_red_2_dark+33}
					borderLeftWidth={1}
					borderRightWidth={1}
					borderColor={Colors.tertirary_red_2_dark}
					style={{alignItems: 'center'}}
				>
					<Warning width={15} height={15}style={{transform:'rotate(180deg)', marginLeft:5,}} color={Colors.tertirary_red_2_dark}/>
					<TextCellAssimetryEvolution fontWeight={600} style={{marginLeft: 5}}>
						{current_language?.abaixo_do_esperado}
						<TextCellAssimetryEvolution fontWeight={600} style={{marginLeft: 15}}>
							•
						</TextCellAssimetryEvolution>
						<TextCellAssimetryEvolution style={{marginLeft: 15}}>
							{current_language?.avaliacao_medica_sugerida}
						</TextCellAssimetryEvolution>
					</TextCellAssimetryEvolution>
				</RowTable>
				{
					dataRows.map((item, index)=>(
						<RowTable
							key={index}
							padding={false}
							borderLeftWidth={1}
							borderRightWidth={1}
							borderBottomWidth={1}
							borderColor={Colors.tertirary_red_2_dark}
						>
							<Cell 
								width={40} 
								bgColor={Colors.tertirary_red_2_dark+33} 
								paddingLeft={5}
								style={{justifyContent: 'flex-start'}}
							>
								<Texts
									title={item.title}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									fontWeight={700}
									textColor={'#414D4A'}
									textAlign={'left'}
									marginTop={5}
									marginBottom={5}
								/>
							</Cell>
							<Cell width={60} paddingLeft={5} 	style={{justifyContent: 'flex-start'}}>
								<Texts
									title={item.value}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									textColor={'#414D4A'}
									textAlign={'left'}
									marginTop={5}
									marginBottom={5}
								/>
							</Cell>
						</RowTable>

					))
				}
			</>
		)
	};
	const HandlerIntermediateComponent = ()=> {

		const HeaderWeakComponent = [
			{	
				title: current_language?.prensao_fraca,
				reference: changeOperators(dataReport?.preensao_palmar?.indicativo_saude?.parametros_fraca) ,
				icon: '',
				width: 20
			},
			{	
				title: current_language?.prensao_intermediaria,
				reference: changeOperators(dataReport?.preensao_palmar?.indicativo_saude?.parametros_intermediaria),
				icon:<AgeGroup65 
								color={Colors.neutral_grey_k_70}
								style={{
									position: 'absolute',
									top:5,
									right:5
								}}
							/>,
				width: 60
			},
			{	
				title: current_language?.prensao_normal,
				reference: changeOperators(dataReport?.preensao_palmar?.indicativo_saude?.parametros_normal),
				icon:'',
				width: 20
			},
		];

		const dataRows = [
			{
				title: current_language?.risco_comprometimento_funcional,
				value: current_language?.impacto_capacidade_funcional,
			},
			{
				title: current_language?.risco_quedas,
				value: current_language?.aumento_risco_quedas,
			},
			{
				title: current_language?.risco_doencas_cronicas,
				value: current_language?.risco_doencas_cronicas,
			},
		];

		return (
			<>
				<ContainerHeaderComponents>
					{
						HeaderWeakComponent.map((item, index)=>(
							<CellHeaderComponents
								key={index}
								width={item.width}
								borderLeftWidth={index == 1 ? 1 : 0}
								borderRightWidth={index == 1 ? 1 : 0}
								borderTopWidth={index == 1 ? 1 : 0}
								borderBottomWidth={index !== 1 ? 1 : 0}
								borderColor={Colors.tertiary_orange_1_light}
								borderTopRightRadius={10}
								borderTopLeftRadius={10}
								bgColor={index == 1 ? Colors.tertiary_yellow_1_light+70 : 'transparent'}
							>
								<Texts
									title={item.title}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									textColor={index == 1 ? Colors.neutral_grey_k_70 : Colors.neutral_grey_k_30}
									fontWeight={index == 1 ? 600 : 400}
									textAlign={'left'}
								/>
								{item.icon}
								<Texts
									title={item.reference}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									textColor={index == 1 ? Colors.neutral_grey_k_70 : Colors.neutral_grey_k_30}
									marginTop={4}
									textAlign={'left'}
								/>
							</CellHeaderComponents>
						))
					}
					
				
				</ContainerHeaderComponents>
				<RowTable
					bgColor={Colors.tertiary_yellow_1_light+70}
					borderLeftWidth={1}
					borderRightWidth={1}
					borderColor={Colors.tertiary_orange_1_light}
					style={{paddingTop:5}}
				>
					<Warning width={15} height={15}style={{transform:'rotate(180deg)', marginLeft:5, }} color={Colors.tertirary_red_2_dark}/>
					<TextCellAssimetryEvolution fontWeight={600} style={{marginLeft: 5}}>
						{current_language?.abaixo_do_esperado}
						<TextCellAssimetryEvolution fontWeight={600} style={{marginLeft: 15}}>
							•
						</TextCellAssimetryEvolution>
						<TextCellAssimetryEvolution style={{marginLeft: 15}}>
							{current_language?.avaliacao_medica_sugerida}
						</TextCellAssimetryEvolution>
					</TextCellAssimetryEvolution>
				</RowTable>
				{
					dataRows.map((item, index)=>(
						<RowTable
							key={index}
							padding={false}
							borderLeftWidth={1}
							borderRightWidth={1}
							borderBottomWidth={1}
							borderColor={Colors.tertiary_orange_1_light}
						>
							<Cell width={40} bgColor={Colors.tertiary_yellow_1_light+70} paddingLeft={5} style={{justifyContent: 'flex-start'}}>
								<Texts
									title={item.title}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									fontWeight={700}
									textColor={'#414D4A'}
									textAlign={'left'}
									marginTop={5}
									marginBottom={5}
								/>
							</Cell>
							<Cell width={60} paddingLeft={5} style={{justifyContent: 'flex-start'}}>
								<Texts
									title={item.value}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									textColor={'#414D4A'}
									textAlign={'left'}
									marginTop={5}
									marginBottom={5}
								/>
							</Cell>
						</RowTable>

					))
				}
			</>
		)
	};

	const HandlerNormalComponent = ()=> {

		const HeaderWeakComponent = [
			{	
				title: current_language?.prensao_fraca,
				reference: changeOperators(dataReport?.preensao_palmar?.indicativo_saude?.parametros_fraca),
				icon: '',
				width: 20
			},
			{	
				title: current_language?.prensao_intermediaria,
				reference: changeOperators(dataReport?.preensao_palmar?.indicativo_saude?.parametros_intermediaria),
				icon:'',
				width: 30
			},
			{	
				title: current_language?.prensao_normal,
				reference: changeOperators(dataReport?.preensao_palmar?.indicativo_saude?.parametros_normal),
				icon:'',
				width: 50
			},
		];

		return (
			<>
				<ContainerHeaderComponents>
					{
						HeaderWeakComponent.map((item, index)=>(
							<CellHeaderComponents
								key={index}
								width={item.width}
								borderLeftWidth={index == 2 ? 1 : 0}
								borderRightWidth={index == 2 ? 1 : 0}
								borderTopWidth={index == 2 ? 1 : 0}
								borderBottomWidth={index !== 2 ? 1 : 0}
								borderColor={Colors.tertiary_green_1_dark}
								borderTopRightRadius={10}
								borderTopLeftRadius={10}
								bgColor={index == 2 ? Colors.tertiary_green_1_light+60 : 'transparent'}
							>
								<Texts
									title={item.title}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									textColor={index == 2 ? Colors.neutral_grey_k_70 : Colors.neutral_grey_k_30}
									fontWeight={index == 2 ? 600 : 400}
									textAlign={'left'}
								/>
								{item.icon}
								<Texts
									title={item.reference}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									textColor={index == 2 ? Colors.neutral_grey_k_70 : Colors.neutral_grey_k_30}
									marginTop={4}
									textAlign={'left'}
								/>
							</CellHeaderComponents>
						))
					}
					
				
				</ContainerHeaderComponents>
				<RowTable
					bgColor={Colors.tertiary_green_1_light+60}
					borderLeftWidth={1}
					borderRightWidth={1}
					borderBottomWidth={1}
					borderColor={Colors.tertiary_green_1_dark}
				>
					<CheckRound width={15} height={15} style={{ marginLeft:5, marginTop:5}} />
					<Texts
						title={current_language?.dentro_do_esperado}
						fontFamily='NotoSans-Regular'
						fontSize={0.75}
						textColor={'#414D4A'}
						fontWeight={700}
						marginLeft={10}
						textAlign={'left'}
						width={'38%'}
						marginTop={5}	
						marginBottom={5}
					/>
					
				</RowTable>
			</>
		)
	};

	const DinamicComponents: keyComponents = {
		'fraca': <HandlerWeakComponent />,
		'intermediaria': <HandlerIntermediateComponent />,
		'normal': <HandlerNormalComponent />,
	};

	const HandlerTable = ()=> {

		const HeadersSection = [
			{
				data: [
					{
						title: `${current_language?.data}: ${
							dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.DATA
							? moment(dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.DATA).format('DD/MM/YYYY') 
							:'-'
						}`,
						titleBold: false,
						valueBold: true,
						value: current_language?.exercise_home,
						textAlign: 'left',
						width: 28 ,
					},
					{
						title: current_language?.direito_d,
						titleBold: true,
						valueBold: false,
						value: `${dataReport?.preensao_palmar?.lado_dominante == 'D' ? current_language?.dominante : current_language?.nao_dominante}`,
						textAlign: 'center',
						width: 26 ,
					},
					{
						title: current_language?.esquerdo_e,
						titleBold: true,
						valueBold: false,
						value: `${dataReport?.preensao_palmar?.lado_dominante == 'E' ? current_language?.dominante : current_language?.nao_dominante}`,
						textAlign: 'center',
						width: 28 ,
					},
					{
						title: current_language?.assimetria + ' atual',
						titleBold: true,
						valueBold: true,
						value: '',
						textAlign: 'center',
						width: 20 ,
					},
				]
			},
		];
		const CompareReferencs =(side: 'D' | 'E', maxExec: number)=> {
			let valueToCompare = null
			if(	dataReport?.preensao_palmar?.lado_dominante == side ){
				valueToCompare = dataReport?.preensao_palmar?.referencia_dominante
			}else{
				valueToCompare = dataReport?.preensao_palmar?.referencia_nao_dominante
			}
			if(!!valueToCompare && maxExec){
				return 	maxExec < valueToCompare ?  <JoiaNegative  color={Colors.tertirary_red_2_dark} style={{marginRight:10}}/> : <JoiaPositivo  color={Colors.secondary_green_k_medium_1} style={{marginRight:10}}/>
			}else{
				return ''
			}
		};

		const DataRowSections = [
			{
				data: [
					{
						title: current_language?.prensao_palmar,
						rightSide: `${dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.MAXEXEC_D 
							? dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.MAXEXEC_D + ' kg'
							: '-' 
						}`,
						rightIcon: dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.indicativo?.lado == 'D' ? <Warning width={15} height={15} color={Colors.tertirary_red_2_dark} style={{marginRight:5}}/> : '',
						leftSide: `${dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.MAXEXEC_E 
							? dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.MAXEXEC_E + ' kg'
							: '-'
						 }`,
						leftSideIcon:dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.indicativo?.lado == 'E' ? <Warning width={15} height={15}color={Colors.tertirary_red_2_dark} style={{marginRight:5}}/> : '',
						currentAssimetry: `${dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.ASSIMETRIA_VALOR 
							? dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.ASSIMETRIA_VALOR 
							: '-'
						
						}`
					},
					{
						title: current_language?.referencia,
						rightSide: `${dataReport?.preensao_palmar?.lado_dominante == 'D' 
								? dataReport?.preensao_palmar?.referencia_dominante + ' kg'
								: dataReport?.preensao_palmar?.referencia_nao_dominante + ' kg'
						}`,
						rightIcon: CompareReferencs('D', dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.MAXEXEC_D) ,
						leftSide: `${dataReport?.preensao_palmar?.lado_dominante == 'E' 
								? dataReport?.preensao_palmar?.referencia_dominante+ ' kg'
								: dataReport?.preensao_palmar?.referencia_nao_dominante+ ' kg'
						}`,
						leftSideIcon: CompareReferencs('E', dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.MAXEXEC_E) ,
						currentAssimetry: ''
					},
				]
			},
		];

		const optionsLegend = [
			{
				title: current_language?.entre_10_20_media,
				subtitle: current_language?.media,
				color: '#FFC53050'
			},
			{
				title: current_language?.acima_de_20_alta,
				subtitle: current_language?.alto,
				color: '#E5887350'
			},
			{
				title: current_language?.abaixo_de_10_baixa,
				subtitle: current_language?.baixa,
				color: '#0CD10050'
			},
			{
				title: current_language?.musculo_mais_forte,
				color: '#768C87'
			},
		];

		return (
			<ContentTable>
				<ContainerSection>
					<Texts
						title={current_language?.assimetria}
						fontFamily='NotoSans-Regular'
						fontSize={0.75}
						textColor={Colors.neutral_grey_k_70}
						fontWeight={600}
					/>
				</ContainerSection>
				<ContainerHeader>
					{
						HeadersSection[0].data.map((item, index)=>(
							<HeaderInfo key={index} width={item.width} >
								<Texts
									title={item.title}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									textColor={Colors.neutral_grey_k_70}
									fontWeight={item.titleBold ? 600 : 400}
									textAlign={item?.textAlign as TitleButtonFormSubmiteProps['textAlign']}
								/>
								<Texts
									title={item.value}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									textColor={Colors.neutral_grey_k_70}
									fontWeight={item.valueBold ? 600 : 400}
									textAlign={item?.textAlign as TitleButtonFormSubmiteProps['textAlign']}
								/>
							</HeaderInfo>
						))
					}
				</ContainerHeader>
				{
					DataRowSections[0]?.data?.map((item, index)=>(
						<RowTable key={index} padding>
							 	<Cell width={31} style={{justifyContent: 'flex-start'}}		>
									<Texts
										title={item.title}
										fontFamily='NotoSans-Regular'
										fontSize={0.75}
										textColor={Colors.neutral_grey_k_70}
										textAlign={item?.title ? 'left' : 'center'}
									/>
								</Cell>
							 	<Cell width={21} >
									{item?.rightIcon}
									<Texts
										title={item?.rightSide?.replace('.',',')}
										fontFamily='NotoSans-Regular'
										fontSize={0.75}
										textColor={Colors.neutral_grey_k_70}
									/>
								</Cell>
							 	<Cell width={ 38 }	>
									{item?.leftSideIcon}
									<Texts
										title={item.leftSide?.replace('.',',')}
										fontFamily='NotoSans-Regular'
										fontSize={0.75}
										marginRight={50}
										textColor={Colors.neutral_grey_k_70}
									/>		
								</Cell>
							 	<Cell 
									width={13} 	
									style={{position: 'relative', justifyContent: 'flex-start'}}
								>
									{item.currentAssimetry != '' &&
										<BgColorCell 
											width={Number(dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.ASSIMETRIA_VALOR?.split('%')[0])} 
											bgColor={AssimetryColors[dataReport?.preensao_palmar?.indicativo_saude?.resultado]}
										/>
									}
									<Texts
										title={item.currentAssimetry}
										fontFamily='NotoSans-Regular'
										fontSize={0.75}
										textColor={Colors.neutral_grey_k_70}
										textAlign={item?.currentAssimetry ? 'left' : 'center'}
									/>		
								</Cell>
						</RowTable>
					))
				}
				<ContainerSection borderTopWidth>
					<Texts
						title={current_language?.indicativos_de_saude}
						fontFamily='NotoSans-Regular'
						fontSize={0.75}
						textColor={Colors.neutral_grey_k_70}
						fontWeight={600}
					/>
				</ContainerSection>
				
				 {DinamicComponents[dataReport?.preensao_palmar?.indicativo_saude?.resultado]} 

				<ContainerLegend>
					<Press onClick={()=> setLegend(!legend)} style={{cursor: 'pointer'}}>
						<Texts
							title={current_language?.legendas}
							fontFamily='NotoSans-Regular'
							fontSize={0.875}
							textAlign='left'
							textColor={Colors.neutral_grey_k_70}
							marginRight={10}
							cursor='pointer'
						/>
						<Arrow
							width={12} 
							height={12} 
							color={Colors.neutral_grey_k_70}
							style={{transform: legend ? 'rotate(0deg)' : 'rotate(-90deg)'	}}
						/>	
					</Press>
					<ContentLegend visible={legend}>
						<Texts
							title={current_language?.assimetria+':'}
							fontFamily='NotoSans-Regular'
							fontSize={0.75}
							textColor={Colors.neutral_grey_k_70}
							fontWeight={600}
							textAlign='left'
						/>
						<ContentOptionLegend >
							<div 
								style={{
									display: 'flex',
									flexDirection: 'row',
								}}
							>
									{
										optionsLegend.slice(0,3).map((item, index)=>(
										
												<OptionL key={index}>
													<Square  bgColor={item.color}/>
													<div style={{display: 'flex', flexDirection: 'column'}}>
														<TextLegend>
															{item.title}
														</TextLegend>
														<TextLegend>
															{item.subtitle}
														</TextLegend>
													</div>
												</OptionL>
										))
									}
							</div>
								{	
									optionsLegend.slice(3).map((item, index)=>(
											<OptionL key={index}>
												<Square  bgColor={item.color}/>
													<TextLegend>
														{item.title}
													</TextLegend>
											</OptionL>
									))
								}
							<Texts
								title={current_language?.definicao_assimetria}
								fontFamily='NotoSans-Regular'
								fontSize={0.75}
								marginTop={6}
								textColor={'#768C87'}
								textAlign='left'
							/>
							<Texts
								title={current_language?.referencia+':'}
								fontFamily='NotoSans-Regular'
								fontSize={0.75}
								marginTop={16}
								textColor={Colors.neutral_grey_k_70}
								fontWeight={600}
								textAlign='left'
							/>
							<ContainerReference >
								<div style={{ display: 'flex', width:'25%', flexDirection: 'row', alignItems: 'center', }}>
									<JoiaPositivo color={Colors.secondary_green_k_medium_1} />
									<Texts
										title={current_language?.dentro_do_esperado}
										fontFamily='NotoSans-Regular'
										fontSize={0.75}
										marginLeft={5}
										textColor={Colors.neutral_grey_k_70}
										textAlign='left'
									/>
								</div>
								<div style={{display: 'flex', width:'25%', flexDirection: 'row'}}>
									<JoiaNegative color={Colors.tertirary_red_2_dark}/>
									<Texts
										title={current_language?.fora_do_esperado}
										fontFamily='NotoSans-Regular'
										fontSize={0.75}
										marginLeft={5}
										textColor={Colors.neutral_grey_k_70}
										textAlign='left'
									/>
								</div>
							</ContainerReference>
							<Texts
								title={current_language?.indicativos_de_saude+':'}
								fontFamily='NotoSans-Regular'
								fontSize={0.75}
								marginTop={16}
								textColor={Colors.neutral_grey_k_70}
								fontWeight={600}
								textAlign='left'
							/>
							<ContainerReference style={{alignItems: 'center'}}>
								<Warning width={15} height={15} color={Colors.tertirary_red_2_dark}/>
								<Texts
									title={current_language?.riscos_saude_preensao_palmar_65}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									marginLeft={5}
									textColor={Colors.neutral_grey_k_70}
									textAlign='left'
								/>
							</ContainerReference>
							<Texts
								title={current_language?.indicativos_de_saude_detalhes}
								fontFamily='NotoSans-Regular'
								fontSize={0.75}
								textColor={'#768C87'}
								textAlign='left'
								marginTop={10}
							/>
						</ContentOptionLegend>
					</ContentLegend>
				</ContainerLegend>
			</ContentTable>
		)
	};

	const AssimetryTable = ()=> {
		const HeadersSection = [
			{
				data: [
					{
						title: current_language?.data,
						value: '',
						titleBold: true,
						valueBold: false,
						textAlign: 'center',
						width: 28 ,
					},
					{
						title: `${current_language?.direito_d}\n`,
						value: dataReport?.preensao_palmar?.lado_dominante == 'D' ? current_language?.dominante : current_language?.nao_dominante,
						titleBold: true,
						valueBold: false,
						textAlign: 'center',
						width: 26 ,
					},
					{
						title:  `${current_language?.esquerdo_e}\n`,
						value: dataReport?.preensao_palmar?.lado_dominante == 'E' ? current_language?.dominante : current_language?.nao_dominante,
						titleBold: true,
						valueBold: false,
						textAlign: 'center',
						width: 28 ,
					},
					{
						title: current_language?.assimetria,
						value: '',
						titleBold: true,
						valueBold: true,
						textAlign: 'center',
						width: 20 ,
					},
				]
			},
		];

		const optionsLegend = [
			{
				title: current_language?.entre_10_20_media,
				subtitle: current_language?.media,
				color: '#FFC53050'
			},
			{
				title: current_language?.acima_de_20_alta,
				subtitle: current_language?.alto,
				color: '#E5887350'
			},
			{
				title: current_language?.abaixo_de_10_baixa,
				subtitle: current_language?.baixa,
				color: '#0CD10050'
			},
			{
				title: current_language?.musculo_mais_forte,
				color: '#768C87'
			},
		];

		return (
			<ContentTable>
				<ContainerHeader>
					{
						HeadersSection[0].data.map((item, index)=>(
							<HeaderInfo key={index} width={item.width} 
								style={{ 
									alignItems:index != 0 ? 'center' : 'flex-start', 
									justifyContent: 'center', 
								}}
							>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center'
									}}
								>
									<TextCellAssimetryEvolution fontWeight={600} align={item.textAlign}>
										{item.title}
									</TextCellAssimetryEvolution>
									<TextCellAssimetryEvolution  align={item.textAlign}>
										{item.value}
									</TextCellAssimetryEvolution>
								</div>
							</HeaderInfo>
						))
					}
				</ContainerHeader>
				{
					dataReport?.preensao_palmar?.assimetrias?.EXECUCOES
					?
						dataReport?.preensao_palmar?.assimetrias?.EXECUCOES
							?.map((
								item: 	{ DATA: moment.MomentInput; MAXEXEC_D: any; indicativo: { lado: string; }; MAXEXEC_E: any; LEGENDA_ASSIMETRIA: string | number; ASSIMETRIA_VALOR: string | Partial<FieldError> | undefined; }, 
								index:number,
								array: string | any[]
							)=>(
								<RowTable 
									key={index} 
									padding
									borderBottomWidth={index == array.length -1 ? 1 : 0 }
									borderColor={Colors.neutral_grey_k_10}
								>
										<Cell width={31} style={{justifyContent: 'flex-start'}} >
											<Texts
												title={moment(item?.DATA).format('DD/MM/YY')}
												fontFamily='NotoSans-Regular'
												fontSize={0.75}
												textColor={Colors.neutral_grey_k_70}
												textAlign={'left'}
											/>
										</Cell>
										<Cell width={21}   >
											<Texts
												title={`${String(item.MAXEXEC_D).replace('.',',')} kg`}
												fontFamily='NotoSans-Regular'
												fontSize={0.75}
												textColor={Colors.neutral_grey_k_70}
												textAlign='left'
												marginLeft={5}
											/>
											{item?.indicativo.lado == 'D'  &&	<Warning width={15} height={15}style={{transform:'rotate(180deg)'}} color={Colors.tertirary_red_2_dark}/>}
										</Cell>
										<Cell width={ 38 }>
										
											<Texts
												title={`${String(item.MAXEXEC_E).replace('.',',')} kg`}
												fontFamily='NotoSans-Regular'
												fontSize={0.75}
												textColor={Colors.neutral_grey_k_70}
											/>		
											{item?.indicativo.lado == 'E'  &&	<Warning width={15} height={15}style={{transform:'rotate(180deg)',marginLeft:5, marginRight:50}} color={Colors.tertirary_red_2_dark}/>}
										</Cell>
										<Cell 	width={13} 	 style={{justifyContent: 'flex-start', position: 'relative'}}	>
											{ <BgColorCell width={Number(dataReport?.preensao_palmar?.assimetrias?.EXECUCOES?.[0]?.ASSIMETRIA_VALOR?.split('%')[0])} bgColor={AssimetryEvolutionColors[item?.LEGENDA_ASSIMETRIA]} />}
											<Texts
												title={item.ASSIMETRIA_VALOR}
												fontFamily='NotoSans-Regular'
												fontSize={0.75}
												textColor={Colors.neutral_grey_k_70}
												textAlign={'left'}
											/>		
										</Cell>
								</RowTable>
							))
					: <Texts
							title={current_language?.nenhum_dado_disponivel}
							fontFamily='NotoSans-Regular'
							fontSize={0.75}
							textColor={Colors.neutral_grey_k_70}
						/>
				}

				<ContainerLegend>
					<Press 
						onClick={()=> setLegend(!legend)}
						style={{width: '10%'}}
					>
						<Texts
							title={current_language?.legendas}
							fontFamily='NotoSans-Regular'
							fontSize={0.875}
							textAlign='left'
							marginRight={10}
							cursor='pointer'
							textColor={Colors.neutral_grey_k_70}
						/>
							<Arrow 
								width={12} 
								height={12} 
								color={Colors.neutral_grey_k_70}
								style={{transform: legend ? 'rotate(0deg)' : 'rotate(-90deg)'	}}
							/>	
					</Press>

					<ContentLegend visible={legend}>
						<Texts
							title={current_language?.assimetria+':'}
							fontFamily='NotoSans-Regular'
							fontSize={0.75}
							textColor={Colors.neutral_grey_k_70}
							fontWeight={600}
							textAlign='left'
						/>
						<ContentOptionLegend>
							<div 
								style={{
									display: 'flex',
									flexDirection: 'row',
								}}
							>
								{
									optionsLegend.map((item, index)=>(
											<OptionL key={index} marginRight={20}>
												<Square  bgColor={item.color}/>
													<div style={{display: 'flex', flexDirection: 'column'}}>
														<TextLegend>
															{item.title}
														</TextLegend>
														<TextLegend>
															{item.subtitle}
														</TextLegend>
													</div>
											</OptionL>
									))
								}

							</div>
							<Texts
								title={current_language?.definicao_assimetria}
								fontFamily='NotoSans-Regular'
								fontSize={0.75}
								marginTop={6}
								textColor={'#768C87'}
								textAlign='left'
							/>
							
							<Texts
								title={current_language?.indicativos_de_saude+':'}
								fontFamily='NotoSans-Regular'
								fontSize={0.75}
								marginTop={16}
								textColor={Colors.neutral_grey_k_70}
								fontWeight={600}
								textAlign='left'
							/>
							<ContainerReference style={{alignItems: 'center'}}>
								<Warning width={15} height={15}style={{transform:'rotate(180deg)'}} color={Colors.tertirary_red_2_dark}/>
								<Texts
									title={current_language?.riscos_saude_preensao_palmar}
									fontFamily='NotoSans-Regular'
									fontSize={0.75}
									marginLeft={5}
									textColor={Colors.neutral_grey_k_70}
									textAlign='left'
								/>
							</ContainerReference>
							<Texts
								title={current_language?.indicativos_de_saude_detalhes}
								fontFamily='NotoSans-Regular'
								fontSize={0.75}
								textColor={'#768C87'}
								textAlign='left'
								marginTop={10}
							/>
						</ContentOptionLegend>
					</ContentLegend>
				</ContainerLegend>

			</ContentTable>
		)
	};

	const HandleGrafic =(dado:any, index:number)=>{

		return (
			<V.VictoryChart width={2300}>
				<V.VictoryGroup offset={65}>
					<V.VictoryBar
						data={dado.arr_d}
						labels={({ datum }) => [datum._y, datum.position]}
						style={{
							data: {
								fill: ({ datum }) => {
									let cor: any = null;
									if (datum.color == TypesCores.POSITIVO) {
										cor = "#7FE179";
									} else if (datum.color == TypesCores.NEGATIVO) {
										cor = "#D12600";
									} else if (
										datum.color == TypesCores.INTERMEDIARIO
									) {
										cor = "#FFC530";
									} else {
										cor = "#797D8D";
									}
									if (datum.y < datum.maior) {
									} else if (
										datum.color == TypesCores.POSITIVO &&
										datum.y === datum.maior
									) {
										cor = "#7FE179";
									} else {
										cor = "#797D8D";
									}
									return cor;
								},
								width: "50",
							},
							labels: {
								fill: "white",
								fontSize: 20,
								fontFamily: "roboto",
							},
						}}
						labelComponent={
							<V.VictoryLabel
								dy={50}
								lineHeight={[3, 1]}
								style={[
									{ fill: ({ datum }) => {
									let cor: any = null;
									if (datum.color == TypesCores.POSITIVO) {
										cor = "#7FE179";
									} else if (datum.color == TypesCores.NEGATIVO) {
										cor = "#D12600";
									} else if (
										datum.color == TypesCores.INTERMEDIARIO
									) {
										cor = "#FFC530";
									} else {
										cor = "#797D8D";
									}
									if (datum.y < datum.maior) {
									} else if (
										datum.color == TypesCores.POSITIVO &&
										datum.y === datum.maior
									) {
										cor = "#7FE179";
									} else {
										cor = "#797D8D";
									}

									return cor;
								}, fontSize: "25px" },
									{ fill: "white", fontSize: "25px" },
								]}
							/>
						}
					/>
					<V.VictoryBar
						data={dado.arr_e}
						labels={({ datum }) => [datum._y, datum.position]}
						style={{
							data: {
								fill: ({ datum }) => {
									let cor: any = null;
									if (datum.color == TypesCores.POSITIVO) {
										cor = "#7FE179";
									} else if (datum.color == TypesCores.NEGATIVO) {
										cor = "#D12600";
									} else if (
										datum.color == TypesCores.INTERMEDIARIO
									) {
										cor = "#FFC530";
									} else {
										cor = "#797D8D";
									}
									if (datum.y < datum.maior) {
									} else if (
										datum.color == TypesCores.POSITIVO &&
										datum.y === datum.maior
									) {
										cor = "#7FE179";
									} else {
										cor = "#797D8D";
									}

									return cor;
								},
								width: "50",
							},
							labels: {
								fill: "white",
								fontSize: 25,
								fontFamily: 'NotoSans-Regular',
							},
						}}
						labelComponent={
							<V.VictoryLabel
								dy={50}
								lineHeight={[3, 1]}
								style={[
									{ fill: ({ datum }) => {
									let cor: any = null;
									if (datum.color == TypesCores.POSITIVO) {
										cor = "#7FE179";
									} else if (datum.color == TypesCores.NEGATIVO) {
										cor = "#D12600";
									} else if (
										datum.color == TypesCores.INTERMEDIARIO
									) {
										cor = "#FFC530";
									} else {
										cor = "#797D8D";
									}
									if (datum.y < datum.maior) {
									} else if (
										datum.color == TypesCores.POSITIVO &&
										datum.y === datum.maior
									) {
										cor = "#7FE179";
									} else {
										cor = "#797D8D";
									}

									return cor;
								}, fontSize: "25px" },
									{ fill: "white", fontSize: "25px" },
								]}
							/>
						}
					/>
				</V.VictoryGroup>

				<V.VictoryAxis
					dependentAxis
					label={current_language?.forca_kg_uper}
					style={{
						axisLabel: {
							fontSize: 25,
							fontFamily: "NotoSans-Regular",
							fill: '#414D4A',
						},

						tickLabels: {
							fontSize: 25,
							fill: "transparent",
						},
						axis: {
							color: "transparent",
							stroke:'#97B3AC'
						},
					}}
				/>

				<V.VictoryAxis
					style={{
						tickLabels: {
							fontSize: 25,
							fill: '#414D4A',
							fontFamily: 'NotoSans-Regular',
							color:'#414D4A'
						},
						
						axis: {
							stroke:'#97B3AC',
						},
					}}
				/>
			</V.VictoryChart>
		)
	};

	return (
		<>
			<ContainerDash >
				<ContainerReport>
					<Return
						style={{cursor:'pointer'}}
						onClick={() => {dispatch(DashBoardActions.set_current_page("perfil_paciente"))}}
					>
						<Icon src={ReturnIcon} style={{ width: "0.875rem", height: "0.875rem" }} />
						<P3Desk style={{ color: Colors?.primary_blue_k_main }}>{current_language?.area_paciente}</P3Desk>
					</Return>
					<ContentUserInfo>
						<div style={{ display: "flex", alignItems: "center" }}>
							<ProfilePicture
								src={patient?.USUARIO_FOTO ? patient?.USUARIO_FOTO : Perfil}
							/>
							<S1Desk style={{ marginLeft: "1rem" }}>
								{patient?.USUARIO_NOME}
							</S1Desk>
						</div>
						<Icon
							style={{ width: "2rem", height: "2rem", cursor: 'pointer' }}
							onClick={() => {	dispatch(DashBoardActions.set_current_page("emissao_relatorios"))	}
							}
							src={  PdfIcon}
						/>
					</ContentUserInfo>
					<ContainerReportOptions>
						{
							reportOptions.map((item, index)=>(
								<ReportOptions 
									onClick={()=> setCurrentoption(item.label)}
									key={index}
									borderColor={currentOption == item.label ? Colors.secondary_green_k_main : Colors.neutral_grey_k_5}
								>
									<Press >
										<ContainerIcon>
											{item.icon}
										</ContainerIcon>
										<Texts
											title={item.title}
											fontFamily='NotoSans-Regular'
											fontSize={1}
											marginLeft={5}
											textColor={Colors.primary_blue_k_main}
											fontWeight={currentOption == item.label ? 600  : 400}
											cursor='pointer'
										/>
									</Press>
								</ReportOptions>
							))
						}
					</ContainerReportOptions>
					{
						currentOption == CurrentOptionSelected.PRENSAO_PALMAR
						?
							<ContainerReportinfo>
									<>
										<ContainerHandImages>
											{
												HandImages.map((item, index)=>(
													HandleImages(item, index)
												))
											}
										</ContainerHandImages>	
										{UpdateResults('center') }
										<ContainerTable>
											<HandlerTable />
										</ContainerTable>
									</>
							</ContainerReportinfo>
						: 
							<ContainerTable style={{marginTop:10,overflowY: 'auto' }}>
								{UpdateResults('center')}	
								<ContainerGrafic>
									{
										currentData.map((dado:any, index:number)=>
											HandleGrafic(dado, index)
										)
									}
									
								</ContainerGrafic>
								<AssimetryTable />
							</ContainerTable>
					}
				</ContainerReport>
			</ContainerDash>
		</>
	)
};

export default ReportPalmar
